import { render } from "./PageHeader.vue?vue&type=template&id=50b78f23&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=50b78f23&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b78f23"]])

export default __exports__